import { FC } from 'react';

import NotificationIcon from '@atlaskit/icon/glyph/notification';

export const NotificationIconSkeleton: FC = () => (
    <div style={{ paddingTop: '6px' }}>
        <NotificationIcon label="Notifications" primaryColor="#344563" secondaryColor="#344563" />
    </div>
);
